import { useLocale } from "../../../context/LanguageContext";

interface VariableChipProps {
  name: string;
  type?: string;
  description?: string | null;
  example?: string | null;
  onClick?: (variableName: string) => void;
  compact?: boolean;
}

export function VariableChip({ name, type, description, example, onClick, compact }: VariableChipProps) {
  const { t } = useLocale();
  const chipContent = `{{${name}}}`;
  const title = [description, example ? t("notifications.variable.example", { example }) : ""].filter(Boolean).join("\n");

  return (
    <button
      type="button"
      onClick={() => onClick?.(name)}
      title={title}
      className={`inline-flex items-center gap-1 rounded-full border font-mono text-xs transition-colors ${
        onClick
          ? "cursor-pointer border-primary/40 bg-primary/5 text-primary hover:border-primary hover:bg-primary/10"
          : "cursor-default border-border bg-muted text-muted-foreground"
      } ${compact ? "px-2 py-0.5" : "px-2.5 py-1"}`}
    >
      <span>{chipContent}</span>
      {type && !compact && (
        <span className="font-sans text-[10px] text-muted-foreground">({type})</span>
      )}
    </button>
  );
}
